import Steps from './Steps'
export { StepsHome } from './Steps'

export default Steps
